import { Task } from '@/types';

// Create a pool of intervention-specific task templates
export const mockInterventionTasks: Task[] = [
  {
    id: 'int-task-1',
    title: 'Weekly Progress Check-in',
    description: 'Schedule weekly meeting with student to review academic progress and address any concerns',
    assignedTo: '',
    dueDate: '',
    status: 'not_started',
    priority: 'medium',
    category: 'academic',
    reminders: [],
    attachments: [],
    comments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'int-task-2',
    title: 'Parent Conference',
    description: 'Schedule and conduct parent conference to discuss intervention progress',
    assignedTo: '',
    dueDate: '',
    status: 'not_started',
    priority: 'high',
    category: 'attendance',
    reminders: [],
    attachments: [],
    comments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'int-task-3',
    title: 'Support Plan Review',
    description: 'Review and update current support plan with teachers and student',
    assignedTo: '',
    dueDate: '',
    status: 'not_started',
    priority: 'high',
    category: 'academic',
    reminders: [],
    attachments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    comments: []
  },
  {
    id: 'int-task-4',
    title: 'Tutoring Program Enrollment',
    description: 'Enroll student in after-school tutoring program',
    assignedTo: '',
    dueDate: '',
    status: 'not_started',
    priority: 'medium',
    category: 'academic',
    reminders: [],
    attachments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    comments: []
  },
  {
    id: 'int-task-5',
    title: 'Behavioral Assessment',
    description: 'Conduct behavioral assessment and document findings',
    assignedTo: '',
    dueDate: '',
    status: 'not_started',
    priority: 'high',
    category: 'behavioral',
    reminders: [],
    attachments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    comments: []
  },
  {
    id: 'int-task-6',
    title: 'Study Skills Workshop',
    description: 'Register student for upcoming study skills workshop series',
    assignedTo: '',
    dueDate: '',
    status: 'not_started',
    priority: 'low',
    category: 'academic',
    reminders: [],
    attachments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    comments: []
  },
  {
    id: 'int-task-7',
    title: 'Health Screening Follow-up',
    description: 'Follow up on health screening results and coordinate with school nurse',
    assignedTo: '',
    dueDate: '',
    status: 'not_started',
    priority: 'medium',
    category: 'health',
    reminders: [],
    attachments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    comments: []
  },
  {
    id: 'int-task-8',
    title: 'Attendance Contract Review',
    description: 'Review and update attendance contract with student and parents',
    assignedTo: '',
    dueDate: '',
    status: 'not_started',
    priority: 'high',
    category: 'attendance',
    reminders: [],
    attachments: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    comments: []
  }
];